import { render, staticRenderFns } from "./Ref.vue?vue&type=template&id=46981ab8&"
import script from "./Ref.vue?vue&type=script&lang=js&"
export * from "./Ref.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports